import styled from '@emotion/styled';
import { css } from 'theme-ui';
import theme from '../../lib/theme';

export const CategoryTabsContainer = styled.div(
  css({
    display: 'flex',
    position: 'absolute',
    left: ['20px', '40px', '295px', '301px', '301px'],
    top: ['188px', '188px', '48px', '48px', '48px'],
    gap: '4px',
  }),
);

export const CategoryTab = styled.div(
  css({
    borderRadius: '2px 2px 0px 0px',
    border: '1px solid var(--gray-ddd, #DDD)',
    boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 0.00) inset',
    fontWeight: 500,
    lineHeight: '22px',
    color: theme.colors.text,
    cursor: 'pointer',
    padding: '9px 24px',
  }),
  ({ $isActive }) =>
    css({
      background: $isActive && 'white',
      borderBottom: $isActive && '1px solid white',
    }),
);

const CategoryTabs = ({
  activeTab,
  handleTabChange,
  displayHistorical,
  displayActive,
}) => (
  <CategoryTabsContainer>
    {displayActive && (
      <CategoryTab
        $isActive={activeTab === 'live'}
        onClick={() => handleTabChange('live')}
      >
        Active
      </CategoryTab>
    )}
    {displayHistorical && (
      <CategoryTab
        $isActive={activeTab === 'historical'}
        onClick={() => handleTabChange('historical')}
      >
        Historical
      </CategoryTab>
    )}
  </CategoryTabsContainer>
);

export default CategoryTabs;
